module.exports = __webpack_public_path__ + "static/media/name.81096382.svg";